import { Injectable, OnDestroy, inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { AppRouter, ROUTER } from '../router/app-router.interface';

import { SystemStatus } from './system-status.domain';
import { SystemStatusService } from './system-status.service';

/**
 * Check system status
 */
@Injectable({
  providedIn: 'root'
})
export class SystemStatusChangeService implements OnDestroy {
  private readonly systemStatusService = inject(SystemStatusService);
  private readonly appRouter = inject<AppRouter>(ROUTER);

  private systemStatusServiceSubscription: Subscription;

  ngOnDestroy(): void {
    if (this.systemStatusServiceSubscription !== undefined) {
      this.systemStatusServiceSubscription.unsubscribe();
    }
  }

  init(): void {
    this.systemStatusService.onSystemStatusChange.subscribe((status: SystemStatus): void => {
      if (status === SystemStatus.MAINTENANCE || status === SystemStatus.DOWN) {
        this.appRouter.navigate('page.errors.maintenance');
      }
    });
  }
}
